const HCP_FORM_DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
  specialty: '',
  npi: '',
  institution: '',
  email: '',
  zip: '',
  phone: '',
  hubspotInfo: false,
  shareInfo: false,
} as const;

const SPECIALTY_OPTIONS = [
  { value: 'Dermatologist', label: 'Dermatologist' },
  { value: 'Podiatrist', label: 'Podiatrist' },
  { value: 'Plastic Surgeon', label: 'Plastic Surgeon' },
  { value: 'General Surgeon', label: 'General Surgeon' },
  { value: 'Vascular Surgeon', label: 'Vascular Surgeon' },
  { value: 'Gerontologist', label: 'Gerontologist' },
  { value: 'Primary Care Physician', label: 'Primary Care Physician' },
  { value: 'Internal Medicine', label: 'Internal Medicine' },
  { value: 'Nurse', label: 'Nurse' },
  { value: 'Hospitalist', label: 'Hospitalist' },
  { value: 'Orthopedic Surgeon', label: 'Orthopedic Surgeon' },
  { value: 'Spine Orthopedic Surgeon', label: 'Spine Orthopedic Surgeon' },
  { value: 'Neurosurgeon', label: 'Neurosurgeon' },
  { value: 'Pain Physician', label: 'Pain Physician' },
  { value: 'Nurse Practitioner', label: 'Nurse Practitioner' },
  { value: 'Physician Assistant', label: 'Physician Assistant' },
  { value: 'Other', label: 'Other' },
];

export { HCP_FORM_DEFAULT_VALUES, SPECIALTY_OPTIONS };
